<template>
  <InfuseModal :title="t('e_connector.users.modal.update.title', { name: user.name })" @close="emit('close')">
    <form ref="form" id="update-user" @submit.prevent="onSave()">
      <div class="flex max-h-[475px] max-w-[965px] flex-col gap-4 overflow-y-auto px-5">
        <div class="flex items-start gap-4">
          <InfuseField :label="t('e_connector.common.user.password')" class="basis-full" size="small">
            <InfuseInput
              type="password"
              size="small"
              v-model="password"
              :minlength="8"
              :placeholder="t('e_connector.users.modal.field.password.placeholder')"
              :required="true"
            />
          </InfuseField>
        </div>

        <div class="flex items-start gap-4">
          <InfuseField
            :label="t('e_connector.users.modal.field.confirmPassword.label')"
            class="basis-full"
            size="small"
            :error="passwordsMatch ? '' : t('e_connector.users.modal.field.confirmPassword.error.noMatch')"
          >
            <InfuseInput
              type="password"
              size="small"
              v-model="confirmPassword"
              :minlength="8"
              :placeholder="t('e_connector.users.modal.field.confirmPassword.placeholder')"
              :required="true"
            />
          </InfuseField>
        </div>
      </div>
    </form>

    <template #actions>
      <InfuseButton color="secondary" @click="emit('close')">
        {{ t('e_connector.common.action.cancel') }}
      </InfuseButton>
      <InfuseButton type="submit" form="update-user" :disabled="loading" :loading="loading">
        {{ t('e_connector.common.action.update') }}
      </InfuseButton>
    </template>
  </InfuseModal>
</template>

<script setup lang="ts">
import { InfuseButton, InfuseField, InfuseInput, InfuseModal } from '@infuse/ui/components';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { User } from '@infuse/e-connector/user/domain';

interface Props {
  loading: boolean;
  user: User;
}

interface Emits {
  (e: 'close'): void;
  (e: 'update', user: User, newPassword: string): void;
}

const { t } = useI18n();

const props = withDefaults(defineProps<Props>(), {
  loading: false
});

const emit = defineEmits<Emits>();

const password = ref<string>('');
const confirmPassword = ref<string>('');

const passwordsMatch = computed(() => !confirmPassword.value || password.value === confirmPassword.value);

function onSave() {
  if (!passwordsMatch.value) {
    return;
  }

  emit('update', props.user, password.value);
}
</script>
